import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { EMPTY, Observable } from 'rxjs';
import { CarouselDocumentsComponent } from 'src/app/shared/carousel-documents/carousel-documents.component';
import { UpdateDataTokenCode } from 'src/app/shared/class/update-data';
import { ConfirmationComponent } from 'src/app/shared/confirmation/confirmation.component';
import {
  DataSelects,
  DetailDocument,
  DocumentCategory,
} from 'src/app/shared/interfaces/data-selects';
import { StepSecondaryDocuments } from 'src/app/shared/interfaces/step-data';
import { RequestInformationComponent } from 'src/app/shared/request-information/request-information.component';
import { DeleteDataService } from 'src/app/shared/services/delete-data.service';
import { GetDataService } from 'src/app/shared/services/get-data.service';
import { PostDataService } from 'src/app/shared/services/post-data.service';
import { PutDataService } from 'src/app/shared/services/put-data.service';
import { RequestFormService } from 'src/app/shared/services/request-form.service';
import { FormsValidators } from 'src/app/shared/utils/forms-validators';
import dayVisitData from '../step-documentos-secundarios-lto/data/day-visit.json';
import timeLapseData from '../step-documentos-secundarios-lto/data/time-lapse.json';
import { DayVisit } from './model/day-visit.interface';
import { TimeLapse } from './model/time-lapse.interface';
import { AutoUnsubscribeComponent } from 'src/app/shared/utils/auto-unsubscribe.component';

@Component({
  selector: 'app-step-documentos-secundarios-lto',
  templateUrl: './step-documentos-secundarios-lto.component.html',
  styleUrls: ['./step-documentos-secundarios-lto.component.scss'],
})
export class StepDocumentosSecundariosLtoComponent
  extends AutoUnsubscribeComponent
  implements OnInit
{
  @Input() saveRequest!: Observable<boolean>;
  @Input() dataSecondaryDocuments!: DataSelects;
  @Output() formValidEvent = new EventEmitter<boolean>();
  @Output() stepSecondaryDocumentsSavedEvent = new EventEmitter<boolean>();
  public formStepSecondaryDocuments!: FormGroup;
  public documentsCategory: DocumentCategory[] = [];
  public stepNumber!: number;
  timeLapse: TimeLapse[] = timeLapseData;
  dayVisit: DayVisit[] = dayVisitData;
  public cameraMovil!: boolean;
  public deletDocument!: boolean;
  public isOpen = false;

  private allowedFileTypes = [
    'image/png',
    'image/jpeg',
    'application/pdf',
    'application/x-compressed',
  ];
  private documentsOpenCameraModelsDelete = [
    'IDENTIFICACIÓN FRENTE',
    'IDENTIFICACIÓN REVERSO',
    'LICENCIA FRENTE',
    'LICENCIA REVERSO',
  ];

  private dowloandCurp = ['CURP'];

  constructor(
    private frmBuilder: FormBuilder,
    private getDataService: GetDataService,
    private postDataService: PostDataService,
    private putDataService: PutDataService,
    private deleteDataService: DeleteDataService,
    private requestFormService: RequestFormService,
    public dialog: MatDialog
  ) {
    super();

    this.formStepSecondaryDocuments = this.frmBuilder.group({
      weekDayOne: ['', [Validators.required]],
      weekDayTwo: ['', [Validators.required]],
      timeRangeOne: ['', [Validators.required]],
      timeRangeTwo: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    if (this.requestFormService.getUpdateForm()) {
      this.loadUpdateFormStep6();
    }

    this.saveRequest.subscribe((value) => {
      if (value) {
        this.saveStep6();
      }
    });
    this.checkEvent();
  }

  ngOnChanges(changes: SimpleChanges) {
    const searchForm = this.requestFormService.getUpdateForm();
    const docTypes = searchForm ? searchForm.documents : [];

    if (!changes['dataSecondaryDocuments']?.currentValue) {
      return;
    }
    this.documentsCategory =
      this.dataSecondaryDocuments.documentCategories.filter(
        (op) => op.name === 'SECUNDARIOS'
      );
    this.documentsCategory.forEach((document) => {
      document.documents = document.documents.map((d) => {
        d.canOpenCamera = this.documentsOpenCameraModelsDelete.includes(d.name);
        d.exceptDocument = this.documentsOpenCameraModelsDelete.includes(
          d.name
        );
        d.delete = this.documentsOpenCameraModelsDelete.includes(d.name);
        d.downloadCurp = this.dowloandCurp.includes(d.name);
        const doc = docTypes.find((docu) => docu.typeId == d.id);
        if (doc) {
          d.uploaded = true;
          d.fileName = doc.fileName;
          d.scanned = doc.scanned;
        }
        return d;
      });
    });
    this.checkEvent();
  }

  checkEvent() {
    if (this.formStepSecondaryDocuments.valid) {
      this.formValidEvent.emit(true);
    } else {
      this.formValidEvent.emit(false);
    }
  }

  getStep6Object(): StepSecondaryDocuments {
    return {
      ...this.formStepSecondaryDocuments.value,
    };
  }

  saveStep6() {
    if (this.formStepSecondaryDocuments.valid) {
      const putUpdateRequestSecondaryDocuments$ = this.putDataService
        .putUpdateRequestSecondaryDocuments(
          this.getCountry().toUpperCase(),
          this.getApplicationId(),
          this.getStep6Object()
        )
        .subscribe({
          next: () => {
            this.stepSecondaryDocumentsSavedEvent.emit(true);
          },
          error: (err) => {
            this.openRequestInformationDialog(err);
          },
        });
      this.subscriptions.push(putUpdateRequestSecondaryDocuments$);
    } else {
      FormsValidators.markFormGroupTouched(this.formStepSecondaryDocuments);
    }
  }

  loadUpdateFormStep6() {
    this.buildForm(this.requestFormService.getUpdateForm());
    this.requestFormService.getUpdateForm().visit?.weekDayOne;

    const dayVisitDayOne = this.dayVisit?.find(
      (op) =>
        op.name === this.requestFormService.getUpdateForm().visit?.weekDayOne
    );
    if (dayVisitDayOne) {
      this.formStepSecondaryDocuments
        .get('weekDayOne')
        ?.setValue(dayVisitDayOne.value);
    }

    const dayVisitDayTwo = this.dayVisit?.find(
      (op) =>
        op.name === this.requestFormService.getUpdateForm().visit?.weekDayTwo
    );
    if (dayVisitDayTwo) {
      this.formStepSecondaryDocuments
        .get('weekDayTwo')
        ?.setValue(dayVisitDayTwo.value);
    }
  }

  buildForm(value: UpdateDataTokenCode) {
    this.formStepSecondaryDocuments.patchValue({
      timeRangeOne: value.visit?.timeRangeOne,
      timeRangeTwo: value.visit?.timeRangeTwo,
    });
  }

  loadDocument(event: any, document: DetailDocument) {
    const fileType = event.target.files[0].type;
    const fileMimeType = event.target.files[0].size < 5000000;

    if (this.allowedFileTypes.includes(fileType) && fileMimeType) {
      const formData = new FormData();
      formData.append('file', event.target.files[0]);
      document.spinner = true;
      const postSaveDocumentLto$ = this.postDataService
        .postSaveDocumentLto(
          this.getCountry().toUpperCase(),
          this.getApplicationId(),
          document.id,
          formData
        )
        .subscribe({
          next: (resp) => {
            document.spinner = false;
            document.uploaded = true;
            document.fileName = resp.fileName;
            document.scanned = resp.scanned!;
          },
          error: (err) => {
            if (
              err.status === 400 &&
              err.error.message === "You can't make another try"
            ) {
              document.uploaded = true;
            }
          },
        });
      this.subscriptions.push(postSaveDocumentLto$);
    } else {
      this.errorFormatDialog();
    }
  }

  errorFormatDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Error de Formato.',
      question: `Solo puede agregar documentos con los siguientes formatos: .PDF, .JPG, .PNG y con un tamaño menor a 5MB. `,
    };
    this.dialog
      .open(ConfirmationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  viewDocuments(doc: DetailDocument) {
    const getViewDocumentsLto$ = this.getDataService
      .getViewDocumentsLto(
        this.getCountry().toUpperCase(),
        this.getApplicationId(),
        doc.fileName
      )
      .subscribe((resp) => {
        const fileURL = URL.createObjectURL(resp);
        window.open(fileURL);
      });
    this.subscriptions.push(getViewDocumentsLto$);
  }

  openViewModelDocuments(doc: DetailDocument) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      documents: doc.helpImageUrl,
    };
    this.dialog
      .open(CarouselDocumentsComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  confirmDeleteDocuments(doc: DetailDocument) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Eliminar',
      question: `¿Desea eliminar el documento : ${doc.name}?`,
    };
    this.dialog
      .open(ConfirmationComponent, dialogConfig)
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          const deleteDocumentsLto$ = this.deleteDataService
            .deleteDocumentsLto(
              this.getCountry().toUpperCase(),
              this.getApplicationId(),
              doc.fileName
            )
            .subscribe({
              next: () => {
                this.successErrorDeleteDocumentDialog();
                doc.uploaded = false;
              },
              error: (err) => {
                this.successErrorDeleteDocumentDialog(err.status);
              },
            });
          this.subscriptions.push(deleteDocumentsLto$);
        }
      });
  }

  successErrorDeleteDocumentDialog(error?: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: error ? 'Error!' : 'Éxito!',
      question: error
        ? `Ha ocurrido un error, no se pudo eliminar el documento.`
        : `El documento se eliminó correctamente. `,
    };
    this.dialog
      .open(ConfirmationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => EMPTY);
  }

  openRequestInformationDialog(event: HttpErrorResponse) {
    let errorMessage = 'Ha ocurrido un error.';

    const errorCoderDocuments = `MISSING_DOCUMENTS`.match(
      event?.error.errors[0].code
    );

    const missingDocumentsMessage = event?.error.errors[0].message;
    if (errorCoderDocuments) {
      errorMessage = `Debe cargar todos los documentos obligatorios (*) requeridos para poder continuar.
      \n${missingDocumentsMessage} `;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Información de solicitud',
      question: errorMessage,
    };

    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => []);
  }

  getApplicationId() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('applicationId')!
      : this.requestFormService.getUpdateForm().id;
  }

  getCountry() {
    return !this.requestFormService.getUpdateForm()
      ? sessionStorage.getItem('language')!
      : this.requestFormService.getUpdateForm().countryCode.code.toLowerCase();
  }
}
